import { PageBuilderIconPropertiesModel } from "@de-trustleap/shared-models";
import { BaseWidget } from "./baseWidget";

export class IconWidget extends BaseWidget<PageBuilderIconPropertiesModel> {
    constructor(properties: PageBuilderIconPropertiesModel) {
        super(properties);
    }

    async render(): Promise<HTMLElement> {
        const wrapper = this.createWrapper();
        const iconElement = this.createIconElement();

        wrapper.appendChild(iconElement);
        this.adjustResponsiveStyling(wrapper);

        return wrapper;
    }

    private createWrapper(): HTMLElement {
        const wrapper = document.createElement("div");
        wrapper.classList.add("icon-widget");

        this.applyStyles(wrapper, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "auto",
        });

        return wrapper;
    }

    private createIconElement(): HTMLElement {
        const icon = document.createElement("i");

        this.applyStyles(icon, {
            fontFamily: "Material Icons",
            fontStyle: "normal",
            fontSize: `${this.properties.size ?? 24}px`,
            color: `#${this.properties.color?.slice(2) ?? "000"}`,
        });

        icon.textContent = this.resolveIconCode(this.properties.code);
        return icon;
    }

    private resolveIconCode(code?: string): string {
        if (!code) return "help";

        try {
            return String.fromCodePoint(parseInt(code, 16));
        } catch (error) {
            console.warn(`Ungültiger Codepoint: ${code}`);
            return "help";
        }
    }

    private adjustResponsiveStyling(wrapper: HTMLElement): void {
        setTimeout(() => {
            const isInsideRow = wrapper.parentElement?.classList.contains("row-widget") ?? false;
            this.applyStyles(wrapper, isInsideRow
                ? {
                      width: "auto",
                      flex: "0 1 auto",
                      justifyContent: "flex-start",
                  }
                : {
                      width: "100%",
                      flex: "1 1 100%",
                  });
        }, 0);
    }
}